import { URL_APP } from 'helpers/config'
import { Box, Button } from '@mui/material'
import TagManager from 'react-gtm-module'
import images from 'assets/images'
import { useLocation, useParams } from 'react-router-dom'
import google, { GoogleStateObject, TypeCreationApp } from 'helpers/integrations/google'
import { RequesterType } from 'helpers/types'

type Props = {
  textButton: string
  typeCreationApp: TypeCreationApp
  id?: string
}

const AuthWithGoogleButton = (props: Props) => {
  const { textButton, typeCreationApp } = props
  const isSignUp = typeCreationApp === 'SIGN_UP'

  const location = useLocation()
  const { productId } = useParams()

  const sendGTMSignup = () => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'signupFormUpdate',
        signupStep: 'signup-google',
      },
    })
  }

  const onClick = () => {
    if (isSignUp) sendGTMSignup()
    const searchParams = new URLSearchParams(location.search)
    const state: GoogleStateObject = {
      redirectUrl: searchParams.get('redirectUrl') || URL_APP,
      typeCreationApp,
      productId,
      requester: searchParams.get('requester') as RequesterType,
      overrideDefaultSignupAction: searchParams.get('overrideDefaultSignupAction') ?? undefined,
    }
    google.connect(state, { onlyBusinessDomain: isSignUp })
  }

  return (
    <Button
      onClick={onClick}
      id={props.id}
      variant="outlined"
      sx={{
        width: '100%',
        textTransform: 'none',
        '&, &:hover': { borderColor: '#1445FE' },
      }}
    >
      <Box display="flex" justifyContent="center" alignItems="center" gap="8px">
        <img alt="imageSlack" src={images.GOOGLE_BUTTON_LOGO} width="20px" />
        <span className="link">{textButton}</span>
      </Box>
    </Button>
  )
}

export default AuthWithGoogleButton
